import { render, staticRenderFns } from "./article-header.vue?vue&type=template&id=256b32da&scoped=true"
import script from "./article-header.vue?vue&type=script&lang=js"
export * from "./article-header.vue?vue&type=script&lang=js"
import style0 from "./article-header.vue?vue&type=style&index=0&id=256b32da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256b32da",
  null
  
)

export default component.exports